import {
  Heart,
  Search,
  UserRound,
  Shield,
  Globe,
  Home,
  SlidersHorizontal,
  ArrowUpDown,
  LayoutGrid,
  Wallet,
  GitCompareArrows,
  Eye,
} from "lucide-react";

/* City-search tour content, ported from the mobile "Search Results" mockup.
   The per-card steps target the FIRST result card, which is the only one
   that carries the tour hooks. The generic GuidedTour engine renders these;
   this is just the data. */
export default function getSearchTourSteps() {
  return [
    {
      cardSelector: '[data-tour="search-fav"]',
      targetSelector: '[data-tour="search-fav"]',
      icon: <Heart />,
      title: "Save cities",
      text: "Tap the heart to save a city, then use it to filter down to just your saved cities.",
    },
    {
      cardSelector: '[data-tour="search-bar"]',
      targetSelector: '[data-tour="search-bar"]',
      icon: <Search />,
      title: "Search",
      text: "Find any of 21,000+ cities by name.",
    },
    {
      cardSelector: '[data-tour="search-filterbar"]',
      targetSelector: '[data-tour="search-filter-role"]',
      icon: <UserRound />,
      title: "Role",
      text: "Set your profession so pay reflects your role.",
    },
    {
      cardSelector: '[data-tour="search-filterbar"]',
      targetSelector: '[data-tour="search-filter-crime"]',
      icon: <Shield />,
      title: "Crime",
      text: "Filter cities by crime level.",
    },
    {
      cardSelector: '[data-tour="search-filterbar"]',
      targetSelector: '[data-tour="search-filter-compact"]',
      icon: <Globe />,
      title: "Compact State",
      text: "Show only nurse-licensure compact states.",
    },
    {
      cardSelector: '[data-tour="search-filterbar"]',
      targetSelector: '[data-tour="search-filter-home"]',
      icon: <Home />,
      title: "Home Price",
      text: "Narrow results by home price range.",
    },
    {
      cardSelector: '[data-tour="search-filterbar"]',
      targetSelector: '[data-tour="search-morefilters"]',
      icon: <SlidersHorizontal />,
      title: "More filters",
      text: "Open the full set of filters for finer control.",
    },
    {
      cardSelector: '[data-tour="search-resultsbar"]',
      targetSelector: '[data-tour="search-sort"]',
      icon: <ArrowUpDown />,
      title: "Sort results",
      text: "Reorder cities by take-home pay, salary, housing cost and more.",
    },
    {
      cardSelector: '[data-tour="search-resultsbar"]',
      targetSelector: '[data-tour="search-view-toggle"]',
      icon: <LayoutGrid />,
      title: "List or grid",
      text: "Switch between list and grid layouts of the results.",
    },
    {
      cardSelector: '[data-tour="search-citycard"]',
      targetSelector: '[data-tour="search-cc-fav"]',
      icon: <Heart />,
      title: "Save this city",
      text: "Bookmark a city to revisit or compare it later.",
    },
    {
      cardSelector: '[data-tour="search-citycard"]',
      targetSelector: '[data-tour="search-cc-keep"]',
      icon: <Wallet />,
      title: "What you keep after housing",
      text: "How much is left each month after rent or a mortgage.",
    },
    {
      cardSelector: '[data-tour="search-citycard"]',
      targetSelector: '[data-tour="search-cc-compare"]',
      icon: <GitCompareArrows />,
      title: "Compare",
      text: "Add this city to a side-by-side comparison.",
    },
    {
      cardSelector: '[data-tour="search-citycard"]',
      targetSelector: '[data-tour="search-cc-view"]',
      icon: <Eye />,
      title: "View details",
      text: "Open the full breakdown for this city.",
    },
  ];
}
